// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3st-P","question":"styles_question__3iBBx","description":"styles_description__138O0"};